import React, {useEffect, useState} from 'react';
import Section from "../../../../../../components/section/Section";
import {copyAsset, getAsset, updateAssetCustomCode} from "../../../../../../api/asset/AssetService";
import {getFlatCode, reversedFlatCode} from "../../../../../../components/commonmethod/CommonMethod";
import ITER_SimmsDrawer from "../../../../../../components/drawer/simms/ITER_SimmsDrawer";
import Selector from "../../../../../../components/selector/Selector";
import {onSubUpdateClickListener} from "../../../../../../components/commonmethod/simmsDrawerMethod";
import {getCodes} from "../../../../../../api/code/CodeService";
import {getFields} from "../../../../../../api/field/FieldService";
import {
    getCustomCodeList,
    getCustomStringList,
    getGroupSelectList
} from "../../../../../../api/field/CustomCodeService";
import CustomSelectBox from "../../../../../../components/select/CustomSelectBox";
import Copy from "../../../../../../resources/icon/copy.png"

function AssetSimpleView({id}) {
    const [asset, setAsset] = useState();
    const [flat, setFlat] = useState([]);
    const [fields, setFields] = useState([]);
    const [customCodes, setCustomCodes] = useState([]);
    const [customStrings, setCustomStrings] = useState([]);
    const [fieldList, setFieldList] = useState([]);
    const [groupSelect, setGroupSelect] = useState([]);

    useEffect(() => {
        getFields()
            .then(res => {
                setFields(res.data);
                return getAsset(id).then(a=>{
                    if(a.status ===200){
                        setAsset(a.data);
                    }else if(a.status===201){
                        if(a.data.errorCode='AUTHORITY'){

                        }
                    }
                })
            })
        getCodes().then(res=>{
            setFlat(getFlatCode(res.data.content))
        });
        getCustomCodeList().then(res=>{    //API >> 사용자 추가 그룹코드
            setCustomCodes(res.data);
        });
        getCustomStringList().then(res=>{    //API >> 사용자 추가 그룹코드
            setCustomStrings(res.data);
        });
        getGroupSelectList().then(r =>
            setGroupSelect([{ id: null, name: "" }, ...r.data]));
    }, [id])

    let c_flat = getFlatCode(customCodes);


    function getFieldListByGroupHierarchy(groupId) {
        const matchedCode = flat.find(each => each.id === groupId);
        const codes = reversedFlatCode(matchedCode, flat)
        setFieldList(fields.filter(each => codes.includes(each.code.id)))
    }

    useEffect(() => {
        getFieldListByGroupHierarchy(asset?.group.id);
    }, [asset]);

    const assetCopy =(id)=>{
        if(window.confirm(`${asset.assetName} 을 복사 하시겠습니까?`)){
            copyAsset(id).then(res=>{
                console.log(res)
                if(res.status === 200){
                    window.location.reload();
                }
            })
        }
    }

    if (asset) {
        return (
            <>
                <div className={`text-[18px] flex drawer-title border-bb`}>
                    <p className={`inline-block`}>{asset.assetName}</p>
                    <abbr title={`자산 복사하기`} className={`ml-auto w-[40px] cursor-pointer`} onClick={() => assetCopy(asset.id)}>
                        <img src={Copy}/>
                    </abbr>
                </div>
                <div className="overflow-y-auto h-[100%]">
                <Section title={"기본정보"}>
                    <table className="w-full table-style">
                        <tbody>
                            <tr>
                                <th className={'w-2/12 line-height-30 truncate'}>등록일시</th>
                                <td className="w-4/12">{asset.createdAt}</td>

                                <th className={'w-2/12 line-height-30 truncate'}>수정일시</th>
                                <td className="w-4/12">{asset.updatedAt}</td>
                            </tr>

                            <tr>
                                <th className={'w-2/12 line-height-30 truncate'}>자산명</th>
                                <td className="w-4/12">{asset.assetName}</td>

                                <th className={'w-2/12 line-height-30 truncate'}>자산코드</th>
                                <td className="w-4/12">{asset.assetCode}</td>
                            </tr>

                            <tr>
                                <th className={'w-2/12 line-height-30 truncate'}>부가정보</th>
                                <td colSpan={3} className="w-4/12">{asset.etc}</td>
                            </tr>

                            <tr>
                                <th className={'w-2/12 line-height-30 truncate'}>시스템</th>
                                <td className="w-4/12"> {asset.project?.name}</td>

                                <th className={'w-2/12 line-height-30 truncate'}>업무그룹</th>
                                <td className="w-4/12">{asset.task?.name}</td>
                            </tr>

                            <tr>
                                <th className={'w-2/12 line-height-30 truncate'}>자산그룹</th>
                                <td className="w-4/12">{asset.group?.name}</td>

                                <th className={'w-2/12 line-height-30 truncate'}>자산위치</th>
                                <td className="w-4/12"> {asset.location?.name}</td>
                            </tr>

                                {/*asset_custom_code*/}
                            {c_flat && customCodes && customCodes.length > 0 &&
                            customCodes.map((code, index) => {
                            const each = asset.assetCustomCodes.find(e => e?.customCode?.id === code.id)
                            const nextEach = asset.assetCustomCodes.find(e => e?.customCode?.id === customCodes[index + 1]?.id);
                            if (customCodes.length % 2 === 1 && index === customCodes.length - 1) {
                                return (
                                    <tr key={index}>
                                        <th className={'w-2/12 line-height-30 truncate'}>{code.name}</th>
                                        <td colSpan={3} className="w-4/12">
                                            <Selector
                                                readOnly
                                                entity={"customCode"}
                                                parentKey={code.id}
                                                uniqueKey={`customCode_${code.id}`}
                                                onChange={(v) =>
                                                    onSubUpdateClickListener(setAsset, updateAssetCustomCode, "assetCustomCodes",
                                                        asset.assetCustomCodes?.[index]?.value,
                                                        {
                                                            id: asset.id,
                                                            subId: code.id,
                                                            subName: 'customCode',
                                                            fieldName: 'value',
                                                            index: index
                                                        },
                                                        v)}
                                                data={each?.value}
                                                recursive/>
                                        </td>
                                    </tr>
                                );
                            }
                            if (index % 2 === 0) {
                                return (
                                    <tr key={index}>
                                        <th className={'w-2/12 line-height-30 truncate'}>{code.name}</th>
                                        <td className="w-4/12">
                                            <Selector
                                                readOnly
                                                entity={"customCode"}
                                                parentKey={code.id}
                                                uniqueKey={`customCode_${code.id}`}
                                                onChange={(v) =>
                                                    onSubUpdateClickListener(setAsset, updateAssetCustomCode, "assetCustomCodes",
                                                        asset.assetCustomCodes?.[index]?.value,
                                                        {
                                                            id: asset.id,
                                                            subId: code.id,
                                                            subName: 'customCode',
                                                            fieldName: 'value',
                                                            index: index
                                                        },
                                                        v)}
                                                data={each?.value}
                                                recursive/>
                                        </td>
                                        {customCodes[index + 1] && (
                                        <>
                                        <th className={'w-2/12 line-height-30 truncate'}>{customCodes[index + 1].name}</th>
                                        <td>
                                            <Selector
                                                readOnly
                                                entity={"customCode"}
                                                parentKey={customCodes[index + 1].id}
                                                uniqueKey={`customCode_${customCodes[index + 1].id}`}
                                                onChange={(v) =>
                                                    onSubUpdateClickListener(setAsset, updateAssetCustomCode, "assetCustomCodes",
                                                        asset.assetCustomCodes?.[index + 1]?.value,
                                                        {
                                                            id: asset.id,
                                                            subId: customCodes[index + 1].id,
                                                            subName: 'customCode',
                                                            fieldName: 'value',
                                                            index: index + 1
                                                        },
                                                        v)}
                                                data={nextEach?.value}
                                                recursive/>
                                        </td>
                                        </>
                                        )}
                                    </tr>
                                );
                            } }) }

                            {/*asset_custom_code*/}
                            {customStrings && customStrings.length > 0 &&
                            customStrings.map((eachCode, index) => {
                            const each = asset.assetCustomStrings.find(e => e?.code?.id === eachCode.id)
                            const next = asset.assetCustomStrings.find(e => e?.code?.id === customStrings[index + 1]?.id)
                            if (customStrings.length % 2 === 1 && index === customStrings.length - 1) {
                                return (

                                    <tr key={index}>
                                        <th className={'w-2/12 line-height-30 truncate'}>{eachCode.name}</th>
                                        <td colSpan={3} className="w-4/12">{each?.value}</td>
                                    </tr>
                                );
                            }
                            if (index % 2 === 0) {
                                return (
                                    <tr key={index}>
                                        <th className={'w-2/12 line-height-30 truncate'}>{eachCode.name}</th>
                                        <td className="w-4/12">{each?.value}</td>
                                        {customStrings[index + 1] && (
                                            <>
                                                <th className={'w-2/12 line-height-30 truncate'}>{customStrings[index + 1].name}</th>
                                                <td>{next?.value}</td>
                                            </>
                                        )}
                                    </tr>
                                );
                            } }) }
                        </tbody>
                    </table>
                </Section>


                <Section title={"유지관리"}>
                    <table className="w-full table-style">
                        <tbody>
                        <tr>
                            <th className={'w-2/12 line-height-30 truncate'}>운영담당자</th>
                            <td className="w-4/12">{asset.operator?.name}</td>

                            <th className={'w-2/12 line-height-30 truncate'}>자산사용자</th>
                            <td className="w-4/12"> {asset.handler?.name}</td>
                        </tr>

                        <tr>
                            <th className={'w-2/12 line-height-30 truncate'}>유지보수업체</th>
                            <td className="w-4/12 truncate">{asset.mngPrimary?.name} / {asset.mngSecondary?.name} / {asset.mngTertiary?.name}</td>

                            <th className={'w-2/12 line-height-30 truncate'}>도입금액</th>
                            <td className="w-4/12"> {asset.importPrice}</td>
                        </tr>

                        <tr>
                            <th className={'w-2/12 line-height-30 truncate'}>도입일자</th>
                            <td className="w-4/12">{asset.importDate}</td>

                            <th className={'w-2/12 line-height-30 truncate'}>End of Service</th>
                            <td className="w-4/12"> {asset.endOfService}</td>
                        </tr>

                        <tr>
                            <th className={'w-2/12 line-height-30 truncate'}>유지보수액</th>
                            <td className="w-4/12">{asset.mngPrice}</td>

                            <th className={'w-2/12 line-height-30 truncate'}>유지보수율</th>
                            <td className="w-4/12"> {asset.mngRate}</td>
                        </tr>

                        </tbody>
                    </table>
                </Section>

                {fieldList &&
                <Section title={"자산정보"}>
                    <table className="w-full create-table ">
                        <tbody>
                        {fieldList.map((field, index) => {
                            const each = asset.assetFields?.find(e => e?.field?.id === field.id)
                                    const actualIndex = asset.assetFields?.findIndex(e => e?.field?.id === field.id);
                                    return (
                                        <React.Fragment key={field.id}>
                                            {field.type === 'INPUT' && (

                                                <tr key={index}>
                                                    <th className={'w-2/12 line-height-30 truncate'}>{field.title}</th>
                                                    <td colSpan={3} className="w-4/12">{each?.value}</td>
                                                </tr>
                                            )}

                                            {field.type === 'USER' && (
                                                    <tr key={index}>
                                                        <th className={'w-2/12 line-height-30 truncate'}>{field.title}</th>
                                                        <td colSpan={3} className="w-4/12">
                                                            <ITER_SimmsDrawer
                                                            readOnly
                                                            entity={"userAccount"}
                                                            uniqueKey={'USER_' + index}
                                                            data={{id: each?.value, rawValue: 'USER'}}
                                                            />
                                                        </td>
                                                    </tr>
                                            )}
                                            {field.type === 'DATE' && (
                                                <tr key={index}>
                                                    <th className={'w-2/12 line-height-30 truncate'}>{field.title}</th>
                                                    <td colSpan={3} className="w-4/12">{each?.value}</td>
                                                </tr>
                                            )}
                                            {field.type === 'TEXT' && (
                                                <tr key={index}>
                                                    <th className={'w-2/12 line-height-30 truncate'}>{field.title}</th>
                                                    <td colSpan={3} className="w-4/12">{each?.value}</td>
                                                </tr>
                                            )}
                                            {field.type === 'SELECT' && (
                                                <tr key={index}>
                                                    <th className={'w-2/12 line-height-30 truncate'}>{field.title}</th>
                                                    <td colSpan={3} className="w-4/12">
                                                        <CustomSelectBox
                                                            readOnly
                                                            target={'value'} entity={'field'}
                                                            subElement={{id: field.id, index: index}}
                                                            options={[
                                                                {id: null, name: ""},
                                                                ...(groupSelect.find(e => e.id === field.entity)?.children)
                                                            ]}
                                                            root={{fnc: setAsset, idx: index}}
                                                            value={each?.value}
                                                        />
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    )
                        })}

                        </tbody>
                    </table>
                </Section>
                }
                </div>
            </>
        );
    }
}

export default AssetSimpleView;